module.exports = __webpack_public_path__ + "static/img/szafa_dso_36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_dso_36.svg
// module id = Hwnt
// module chunks = 0